import { doc, getDoc } from 'firebase/firestore';
import { fs } from '../firebase';

const DEFAULT_POINTS_PER_GEL = 100;

export async function getLoyaltyPointsRate() {
    try {
        const snapshot = await getDoc(doc(fs, 'settings', 'loyalty'));
        const value = Number(snapshot.data()?.pointsPerGel);
        if (Number.isFinite(value) && value > 0) {
            return value;
        }
    } catch (error) {
        console.error('[LOYALTY-RATE] Failed to read settings/loyalty.pointsPerGel:', error);
    }
    return DEFAULT_POINTS_PER_GEL;
}

export function calculateLoyaltyPoints(totalGel, rate) {
    const total = Number(totalGel);
    if (!Number.isFinite(total) || total <= 0) return 0;
    return Math.floor(total * rate);
}
